/* SLIDE 16 */

import React from "react";
import cardIcon from "assets/icons/cardIcon.svg";
import { useNavigate } from "react-router-dom";
import { TailSpin, ThreeDots } from 'react-loader-spinner';

const ParkingPaymentSuccess = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/menu_manager", { replace: true });
  }

  return (
    <div className="htContainer htPaymentSuccess" onClick={handleClick}>

      <img src={cardIcon} alt="Card" />
      <div className="htPsTile">결제중입니다</div>
      <div className="htPsDesc">나이스페이먼츠 결제 모듈 영역</div>


      <ThreeDots
        height="60"
        width="60"
        color="#4fa94d"
        ariaLabel="loading"
      />
    </div>
  );
};

export default ParkingPaymentSuccess;